import React from "react";
import { cn } from "@/lib/utils";

function Chip({ active, onClick, children, disabled, className }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={cn(
        "px-3 py-2 rounded-soft border text-sm transition-all",
        active
          ? "bg-rose-100 text-rose-900 border-rose-200 shadow"
          : "bg-white border-neutral-300 hover:border-rose-300",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      aria-pressed={active}
    >
      {children}
    </button>
  );
}

export { Chip };
